import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { colors, focusOutline } from '../../styles/theme'

const S = {}

const disabledState = css`
  cursor: default;
  color: ${colors.silverChalice};

  .checkmark {
    border-color: ${colors.silverChalice};
  }
`

const activeState = ({ accentColor }) => css`
  color: ${colors.white};

  .checkmark {
    border-color: ${colors.white};
  }

  input:checked ~ .checkmark {
    border: 0.125rem solid ${accentColor ? accentColor : colors.scooter};
  }
`

S.Radio = styled.label`
  position: relative;
  color: ${colors.silverChalice};
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.15s cubic-bezier(0.5, 0, 0.25, 1);
  padding: 0.125rem;
  margin: 0.125rem;
  opacity: ${({ isDisabled }) => isDisabled && 0.5};
  ${focusOutline};

  @media (hover: hover) {
    &:hover {
      ${({ isDisabled }) => (isDisabled ? disabledState : activeState)};
    }
  }

  &:focus, &:focus-within {
    ${({ isDisabled }) => (isDisabled ? disabledState : activeState)};
  }

  .radio-wrapper {
    position: relative;
    margin-inline-end: 0.5rem;
  }
`

S.Input = styled.input`
  opacity: 0;
  position: relative;
  z-index: 1;

  &:checked ~ span[type='copy'] {
    color: ${colors.white};
  }

  &:checked ~ .checkmark {
    border: 0.125rem solid
      ${({ accentColor }) => (accentColor ? accentColor : colors.scooter)};

    &::after {
      opacity: 1;
    }
  }

  &:disabled ~ .label {
    color: ${colors.silverChalice};
  }

  &:disabled ~ .checkmark {
    border-color: ${colors.silverChalice};

    &::after {
      background-color: ${colors.silverChalice};
    }
  }
`

S.Checkmark = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  background-color: ${colors.crBlueDark};
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  border: 0.125rem solid ${colors.silverChalice};
  transition: border-color 0.15s cubic-bezier(0.5, 0, 0.25, 1);
  box-sizing: border-box;
  flex-shrink: 0;

  &::after {
    position: absolute;
    display: block;
    background-color: ${({ accentColor }) =>
      accentColor ? accentColor : colors.scooter};
    inset-inline-start: 50%;
    inset-block-start: 50%;
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.15s cubic-bezier(0.5, 0, 0.25, 1);

    html:not([dir]) &,
    [dir='ltr'] & {
      transform: translate(-50%, -50%);
    }

    [dir='rtl'] & {
      transform: translate(50%, -50%);
    }
  }
`

export default S
